/**
 * Generated bundle index. Do not edit.
 */

export * from './breadcrumbs-public-api';

export {BreadcrumbsService as ɵa} from './breadcrumbs/services/breadcrumb.service';